(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-media-gallery-content"] && !Shopify.designMode) return;
  try {
    // Scroll events do not bubble; capture catches swipes and thumbnail navigation.
  document.addEventListener('scroll', (event) => {
    const gallery = event.target;
    if (!(gallery instanceof HTMLElement) ||
        !gallery.matches('.seed-style-zoom .dialog-zoomed-gallery')) return;

    const dialog = gallery.closest('zoom-dialog');
    const thumbnails = dialog?.querySelector('.dialog-thumbnails-list');
    if (!thumbnails || !gallery.clientWidth) return;

    const slides = Array.from(gallery.children);
    const galleryRect = gallery.getBoundingClientRect();
    const center = galleryRect.left + galleryRect.width / 2;
    let activeIndex = 0;
    let closestDistance = Infinity;

    slides.forEach((slide, index) => {
      const rect = slide.getBoundingClientRect();
      const distance = Math.abs(rect.left + rect.width / 2 - center);
      if (distance < closestDistance) {
        closestDistance = distance;
        activeIndex = index;
      }
    });

    const buttons = Array.from(thumbnails.querySelectorAll('button'));
    const active = buttons[activeIndex];
    if (!active || active.getAttribute('aria-selected') === 'true') return;

    buttons.forEach((button, index) => {
      button.setAttribute('aria-selected', String(index === activeIndex));
    });

    // Scroll only the thumbnail strip, keeping the main swipe uninterrupted.
    const stripRect = thumbnails.getBoundingClientRect();
    const activeRect = active.getBoundingClientRect();
    thumbnails.scrollBy({
      left: activeRect.left + activeRect.width / 2 - stripRect.left - stripRect.width / 2,
      behavior: 'instant',
    });
  }, { capture: true, passive: true });
  } catch(e) { console.error(e); }
})();

})();
